import FieldSkeleton from '@api/order/components/CellLoaders/FieldSkeleton'
import { CellItem } from '@components/UI-Components/HierarchyWiseItemsTable/components/Row/Cell'
import get from 'lodash/get'
import React, { FC } from 'react'
import EnhancedCell from './EnhancedCell'
import { CentricTypography as Typography } from '@core/component/CentricTypography'
import formatCurrencyValueByLocale from '@utils/format-currency-value-by-locale'
import { getKPICurrency } from '@modules/order/utils/get-kpi-currency'
import { nav } from '@stores'
import useOrderContext from '@modules/order/hooks/use-order-context'

const EnhancedCurrency: FC<CellItem> = ({ rowData, column }) => {
  const {
    uiStore: {
      dataStore: { summary }
    }
  } = useOrderContext()

  const currency = getKPICurrency(nav.queryParams.orderType, summary)

  if (!rowData) {
    return <FieldSkeleton />
  }
  const value = get(rowData, column.enhancedField)

  return (
    <EnhancedCell>
      <Typography variant='h6'>
        {formatCurrencyValueByLocale(currency, value || 0)}
      </Typography>
    </EnhancedCell>
  )
}

export default EnhancedCurrency
